import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getImages } from "../Const";

const ExportButton = ({ visibleData }) => {
  const handleExport = () => {
    if (!visibleData || visibleData.length === 0) {
      alert("No data available to export");
      return;
    }

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(visibleData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Visible Data");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `visible_data_${new Date().toISOString()}.xlsx`);
  };

  return (
    <button type='button' className='blue-transparent-btn dark-transparent-btn' onClick={handleExport}><img className='me-2' src={getImages('export_icon.svg')}/> Export Appraisals</button>
  );
};

export default ExportButton;
